/*
 * @providesModule NotifyMeAPI
 */

import NetClient from 'NetClient';
import {NativeModules} from 'react-native';

const SKZAPIManager = NativeModules.SKZAPIManager;

/**
 * Register user for live bracket notifications
 * @param bracketId - The ID of the live bracket
 * @returns Promise that resolves with the API response
 */
export const notifyMe = (bracketId: string): Promise<Object> => {
  if (!bracketId) {
    return Promise.reject({name: 'BRACKET_ID_ERROR'});
  }

  const url = `/v2/live-brackets/${bracketId}/register-notify-user`;
  const retryMode = SKZAPIManager.OnError.failSilently;

  return new Promise((resolve, reject) => {
    NetClient.postURL(url, {}, retryMode, (error: unknown, payload: unknown) => {
      if (error) {
        reject(error);
      } else {
        resolve(payload || {});
      }
    });
  });
};

/**
 * Register user for live bracket notifications (convenience method)
 * @param bracketId - The ID of the live bracket
 * @returns Promise that resolves with the API response
 */
export const registerNotifyUser = (bracketId: string): Promise<Object> => {
  return notifyMe(bracketId);
};
